/**
 * Get the uri for the infograph service
 *
 * @param path the path to the infograph service (e.g. /api/design/create)
 * @returns the full uri to the infograph service (e.g. https://infograph.venngage.com/api/design/create)
 */
export const getInfographUri = (path: string) => {
  const validatedPath = path.startsWith('/') ? path : `/${path}`;

  const currentProtocol = window.location.protocol;
  const currentHostname = window.location.hostname;

  // Home page pre-staging
  if (currentHostname.endsWith('.dev.venngage.beer')) {
    // This is hard coded for now. We do not have a proper pre-staging yet.
    return `${currentProtocol}//ai.infograph-dev.venngage.beer${validatedPath}`;
  }

  // infograph and the e2 pre staging
  if (currentHostname.endsWith('-dev.venngage.beer')) {
    // infogra and the e2 pre staging are under the same domain
    return path;
  }

  // E2 standalone, use the beer domain
  if (currentHostname.endsWith('venngage.vercel.app')) {
    return `${currentProtocol}//infograph.venngage.beer${validatedPath}`;
  }

  if (currentHostname.endsWith('localhost') || currentHostname.endsWith('.local')) {
    return path;
  }

  // Others such as staging and production
  const hostname = currentHostname.startsWith('infograph') ? currentHostname : `infograph.${currentHostname}`;

  return `${currentProtocol}//${hostname}${validatedPath}`;
};
